import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=0773e3db&scoped=true"
import script from "./Player.vue?vue&type=script&lang=ts"
export * from "./Player.vue?vue&type=script&lang=ts"
import style0 from "./Player.vue?vue&type=style&index=0&id=0773e3db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0773e3db",
  null
  
)

export default component.exports